export default __webpack_public_path__ + "static/media/Sikkhism-in-Burhanpur.70cf0e90.jpg";